export type PlatformType = "iOS" | "Android" | "PC" | "Unknown";
export const getPlatform = (): PlatformType => {
  const userAgent = navigator.userAgent;
  console.log("userAgent", userAgent);
  // 检测是否为 iOS 设备
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return "iOS";
  }
  // 检测是否为 Android 设备
  if (/Android/i.test(userAgent)) {
    return "Android";
  }
  // 如果都不是移动设备，则可能为PC浏览器或其他桌面设备
  if (/Windows NT|Macintosh|Linux/i.test(userAgent)) {
    return "PC";
  }
  // 对于无法识别的设备类型，可返回默认值或者其他标识
  return "Unknown";
};

export const getBrowserLanguage = () => {
  return (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // navigator.userLanguage在一些较老的浏览器中被使用
    //@ts-ignore
    navigator.userLanguage
  );
};

export const getQueryString = (name: string) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
